<div class="flex items-center justify-between">
    <div #title>{{widgetHeader()}}</div>
    <div #action>
      <p-select
        [(ngModel)]="option"
        [options]="chartRanges"
        class="mr-6 chart-canvas"
        optionLabel="name"
        optionValue="unit"
        placeholder="Select a Range"
        styleClass="w-46 w-full" />
    </div>
</div>
<div>
  <p-chart type="line" [data]="chartData" [plugins]="plugins" [options]="chartOptions"></p-chart>
</div>